"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSystemParameter = exports.login2faRender = exports.ChangePasswordRender = exports.TransactionSigningRender = exports.loadingRender = exports.globalErrorRender = exports.activeSessionDialog = exports.passwordExpireSoonDialog = exports.sessionTimeoutDialog1 = exports.closeAllPopUp = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const history_1 = require("history");
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const TransactionSigning_1 = __importDefault(require("@/features/transaction-signing/containers/TransactionSigning"));
const Login2faRenderInner_1 = __importDefault(require("@/features/login2fa/containers/Login2faRenderInner"));
const en_default_json_1 = __importDefault(require("@/assets/translation/en-US/en_default.json"));
const ms_default_json_1 = __importDefault(require("@/assets/translation/ms-MY/ms_default.json"));
const zh_default_json_1 = __importDefault(require("@/assets/translation/zh-CN/zh_default.json"));
const ActiveSessionFoundPopup_1 = __importDefault(require("./components/session/ActiveSessionFoundPopup"));
const IdleSessionTimeoutDialog_1 = __importDefault(require("./components/session/IdleSessionTimeoutDialog"));
const client_1 = require("react-dom/client");
const transactionSigningAction_1 = require("@/features/transaction-signing/actions/transactionSigningAction");
const config_1 = require("./config");
const transaction_signing_store_1 = require("./store/transaction-signing-store");
const App_1 = __importDefault(require("./App"));
const getSecurityPolicy_1 = __importDefault(require("@/data-manager/ms-sys-param/getSecurityPolicy"));
const transactionSigningApi_1 = require("@/features/transaction-signing/apis/transactionSigningApi");
const PasswordExpireSoonPopup_1 = __importDefault(require("./components/session/PasswordExpireSoonPopup"));
const GlobalErrorHandler_1 = require("./GlobalErrorHandler");
const styles_1 = require("@mui/styles");
const generateClassName = (0, styles_1.createGenerateClassName)({
    productionPrefix: 'digital-core-mfe-my-bfo-stitcher-'
});
// if (currentBg !== expectBg) {
//  document.body.style.background = expectBg;
// }
// const setBackGround = () => {
// 	// if (path.indexOf('/main/login') > -1 || path.indexOf('/login') || path.indexOf('/logout') > -1) {
// 	//   document.body.style.background = expectBg;
// 	//   return;
// 	// }
// 	const loginContextStr = sessionStorage.getItem('LoginContext')
// 	const loginContext = typeof loginContextStr === 'string' ? JSON.parse(loginContextStr) : loginContextStr
// 	if (loginContext && loginContext['x-acc-op']) {
// 		document.body.classList.remove('pre-login-container')
// 		return
// 	}
// 	document.body.classList.add('pre-login-container')
// }
const loaderContainer = document.getElementById('loader');
const loaderRoot = (0, client_1.createRoot)(loaderContainer);
const loadingRender = ({ loading }) => {
    loaderRoot.render(react_1.default.createElement(App_1.default, { loading: loading }));
};
exports.loadingRender = loadingRender;
const getSystemParameter = () => __awaiter(void 0, void 0, void 0, function* () {
    yield (0, getSecurityPolicy_1.default)('SPCFOMY003').then(data => {
        window.sessionStorage.setItem('sessionOutTime', data.value);
    });
    yield (0, getSecurityPolicy_1.default)('SPCFOMY004').then(data => {
        window.sessionStorage.setItem('sessionOutTimeInterval', data.value);
    });
    yield (0, getSecurityPolicy_1.default)('SPCFOMY001').then(data => {
        window.sessionStorage.setItem('absoluteTimeout', data.value);
    });
    yield (0, getSecurityPolicy_1.default)('SPCFOMY002').then(data => {
        window.sessionStorage.setItem('absoluteOutTimeInterval', data.value);
    });
});
exports.getSystemParameter = getSystemParameter;
const transactionSigningRender = 'transaction-signing-render';
const transactionSigningContainer = document.getElementById(transactionSigningRender);
const transactionSigningRoot = (0, client_1.createRoot)(transactionSigningContainer);
const TransactionSigningRender = ({ isHidden, paramProps, onSuccess, onFailure, onClose, onCancel }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    if (isHidden) {
        setTimeout(() => transactionSigningRoot.render(null));
    }
    else {
        const authRequestDetail = yield (0, transactionSigningApi_1.apiGetAuthRequest)(paramProps.authorizationId, {});
        const authorizationTypeCode = (_b = (_a = authRequestDetail === null || authRequestDetail === void 0 ? void 0 : authRequestDetail.allowedMethods) === null || _a === void 0 ? void 0 : _a.methods) === null || _b === void 0 ? void 0 : _b[0];
        const otpType = (_c = authRequestDetail === null || authRequestDetail === void 0 ? void 0 : authRequestDetail.context) === null || _c === void 0 ? void 0 : _c.otpType;
        transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.startTransactionSigningWorkFlow)());
        transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setTransactionSigningCallbackSuccess)(onSuccess));
        transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setTransactionSigningCallbackFailure)(onFailure));
        if (!authorizationTypeCode) {
            console.log('No authzTypeCode provided, show general error');
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.callTransactionSigningFailureCallback)());
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.endTransactionSigningWorkFlow)());
        }
        else {
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAuthRequestDetail)(authRequestDetail));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAccessToken)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.accessToken));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAuthorizationTypeCode)(authorizationTypeCode));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAuthorizationId)(paramProps.authorizationId));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAuthorizationReference)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.authorizationReference));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setTransactionId)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.transactionId));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setMaskedMobileNo)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.maskedMobileNo));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setResetIndicator)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.resetIndicator));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setDynamicLabel)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.dynamicLabel));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setRefcode)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.refcode));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setInputData)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.inputData));
            if (authorizationTypeCode.toString().toLowerCase() === 'sms_otp') {
                transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.showTransactionSigningOTPLayout2)());
                // store.dispatch(showFirstTimeTransactionSigningLayout());
            }
            else if (authorizationTypeCode.toString().toLowerCase() === 'email_otp') {
                transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.showTransactionSigningEmailVerification)());
            }
            else if (authorizationTypeCode.toString().toLowerCase() === 'soft') {
                if ((authRequestDetail === null || authRequestDetail === void 0 ? void 0 : authRequestDetail.trxType) === 'SELF_CHANGE_PWD') {
                    transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.startChangePassword)());
                }
                else {
                    transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.startTransactionSiging)());
                }
                // yield delay(2000);
            }
            else if (authorizationTypeCode.toString().toLowerCase() === 'hard') {
                if (otpType === 'CR') {
                    transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.showTransactionSigningHardTokenOTPNoFinancial)());
                }
                else {
                    transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.showTransactionSigningHardTokenOTP)());
                    // yield put(setLayoutStatus(LayoutStatus.HARD_WARE_TOKEN));
                }
            }
            else {
                transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.callTransactionSigningFailureCallback)());
                transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.endTransactionSigningWorkFlow)());
            }
            // switch (authorizationTypeCode.toString().toLowerCase()) {
            //   case 'sms_otp':
            //     store.dispatch(showTransactionSigningOTPLayout2());
            //     // store.dispatch(startAuthorizationStatus());
            //     break;
            //   case 'email_otp':
            //     store.dispatch(showTransactionSigningEmailVerification());
            //     break;
            //   case 'swk':
            //     // yield delay(2000);
            //     store.dispatch(startAuthorizationStatus());
            //     // yield delay(2000);
            //     break;
            //   case 'hard':
            //     break;
            //   default:
            // if success --> callback success ELSE GENERAL ERROR (callback failure)
            // store.dispatch(showTransactionSigningOTPLayout2());
            // transactionSigningCallback();
            // break;
        }
    }
    transactionSigningRoot.render(react_1.default.createElement(ComponentWrapper, null,
        react_1.default.createElement(TransactionSigning_1.default, { onClose: onClose })));
});
exports.TransactionSigningRender = TransactionSigningRender;
const closeAllPopUp = () => __awaiter(void 0, void 0, void 0, function* () {
    transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setErrorMsg)(undefined));
    transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.toggleCloseHardTokenOtp)());
    transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.toggleCloseOneToken)());
    transactionSigningRoot.render(null);
});
exports.closeAllPopUp = closeAllPopUp;
const changePasswordContainer = document.getElementById(transactionSigningRender);
const changePasswordRoot = (0, client_1.createRoot)(changePasswordContainer);
const ChangePasswordRender = ({ isHidden, paramProps, onSuccess, onFailure, onClose, onCancel }) => __awaiter(void 0, void 0, void 0, function* () {
    var _d, _e;
    if (isHidden) {
        setTimeout(() => changePasswordRoot.render(null));
    }
    else {
        const authRequestDetail = yield (0, transactionSigningApi_1.apiGetAuthRequest)(paramProps.authorizationId, {});
        const authorizationTypeCode = (_e = (_d = authRequestDetail === null || authRequestDetail === void 0 ? void 0 : authRequestDetail.allowedMethods) === null || _d === void 0 ? void 0 : _d.methods) === null || _e === void 0 ? void 0 : _e[0];
        transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.startTransactionSigningWorkFlow)());
        transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setTransactionSigningCallbackSuccess)(onSuccess));
        transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setTransactionSigningCallbackFailure)(onFailure));
        if (!authorizationTypeCode) {
            console.log('No authzTypeCode provided, show general error');
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.callTransactionSigningFailureCallback)());
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.endTransactionSigningWorkFlow)());
        }
        else {
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAuthRequestDetail)(authRequestDetail));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAccessToken)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.accessToken));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAuthorizationTypeCode)(authorizationTypeCode));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAuthorizationId)(paramProps.authorizationId));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setAuthorizationReference)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.authorizationReference));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setTransactionId)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.transactionId));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setMaskedMobileNo)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.maskedMobileNo));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setResetIndicator)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.resetIndicator));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setDynamicLabel)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.dynamicLabel));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setRefcode)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.refcode));
            transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.setInputData)(paramProps === null || paramProps === void 0 ? void 0 : paramProps.inputData));
            if (authorizationTypeCode.toString().toLowerCase() === 'soft') {
                transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.startChangePassword)());
                transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.startAuthorizationStatus)());
                // yield delay(2000);
            }
            else if (authorizationTypeCode.toString().toLowerCase() === 'hard') {
                transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.showTransactionSigningHardTokenOTP)());
                // yield put(setLayoutStatus(LayoutStatus.HARD_WARE_TOKEN));
            }
            else {
                transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.callTransactionSigningFailureCallback)());
                transaction_signing_store_1.store.dispatch((0, transactionSigningAction_1.endTransactionSigningWorkFlow)());
            }
        }
    }
    changePasswordRoot.render(react_1.default.createElement(ComponentWrapper, null,
        react_1.default.createElement(TransactionSigning_1.default, { onClose: onClose })));
});
exports.ChangePasswordRender = ChangePasswordRender;
const loginContainer = document.getElementById('login2fa-render');
const loginRoot = (0, client_1.createRoot)(loginContainer);
const login2faRender = props => {
    const { publicPath = '' } = props;
    const history = (0, history_1.createBrowserHistory)({ basename: publicPath });
    loginRoot.render(react_1.default.createElement(ComponentWrapper, null,
        react_1.default.createElement(react_router_dom_1.Router, { history: history },
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, key: "/others", render: () => react_1.default.createElement(Login2faRenderInner_1.default, Object.assign({}, props)) }))));
};
exports.login2faRender = login2faRender;
const ComponentWrapper = props => (react_1.default.createElement(react_redux_1.Provider, { store: transaction_signing_store_1.store },
    react_1.default.createElement(styles_1.StylesProvider, { generateClassName: generateClassName },
        react_1.default.createElement(styles_1.ThemeProvider, { theme: config_1.theme },
            react_1.default.createElement(MultiLanguageWrapper, Object.assign({}, props), props.children)))));
const sessionContainer = document.getElementById('session');
const sessionRoot = (0, client_1.createRoot)(sessionContainer);
const sessionTimeoutDialog1 = ({ sessionTimeoutDialog, date, registerConfig, idleSessionTimeout, sessionExpired, getGlobalState, setGlobalState, idleSessionTimeoutGracePeriodTimeout }) => {
    sessionRoot.render(react_1.default.createElement(ComponentWrapper, null,
        react_1.default.createElement(IdleSessionTimeoutDialog_1.default, { sessionTimeoutDialog: sessionTimeoutDialog, date: date, registerConfig: registerConfig, idleSessionTimeout: refreshSession => idleSessionTimeout(refreshSession, getGlobalState, setGlobalState), sessionExpired: registerConfig1 => sessionExpired(registerConfig1, getGlobalState, setGlobalState), getGlobalState: getGlobalState, setGlobalState: setGlobalState, idleSessionTimeoutGracePeriodTimeout: idleSessionTimeoutGracePeriodTimeout })));
};
exports.sessionTimeoutDialog1 = sessionTimeoutDialog1;
const passwordExpireSoonContainer = document.getElementById('passwordExpireSoon');
const passwordExpireSoonRoot = (0, client_1.createRoot)(passwordExpireSoonContainer);
const passwordExpireSoonDialog = (getGlobalState, userSettingPage) => {
    passwordExpireSoonRoot.render(react_1.default.createElement(ComponentWrapper, null,
        react_1.default.createElement(PasswordExpireSoonPopup_1.default, { getGlobalState: getGlobalState, userSettingPage: userSettingPage })));
};
exports.passwordExpireSoonDialog = passwordExpireSoonDialog;
const activeSessionContainer = document.getElementById('active-session');
const activeSession = (0, client_1.createRoot)(activeSessionContainer);
const activeSessionDialog = ({ _activeSessionDialog, date, getGlobalState, setGlobalState }) => {
    activeSession.render(react_1.default.createElement(ComponentWrapper, null,
        react_1.default.createElement(ActiveSessionFoundPopup_1.default, { activeSessionDialog: _activeSessionDialog, date: date, getGlobalState: getGlobalState, setGlobalState: setGlobalState })));
};
exports.activeSessionDialog = activeSessionDialog;
const MultiLanguageWrapper = props => {
    const { language } = props;
    const languageInner = language || sessionStorage.getItem('language') || 'en-US';
    console.log('[mfe-my-bfo-stitcher] languageInner: ', languageInner);
    const messages = {
        'en-US': {
            Common: en_default_json_1.default
        },
        'en-GB': {
            Common: en_default_json_1.default
        },
        'ms-MY': {
            Common: ms_default_json_1.default
        },
        'zh-CN': {
            Common: zh_default_json_1.default
        }
    };
    const localeMessages = messages[languageInner];
    const contentMessage = Object.assign({}, localeMessages === null || localeMessages === void 0 ? void 0 : localeMessages.Common);
    //const [contentMessageState, setContentMessageState] = useState(contentMessage)
    const [contentMessageState] = (0, react_1.useState)(contentMessage);
    //const getUrl2_1 = language => {
    //	const { multiLanguageSubUrl } = getConfig()
    //	switch (language) {
    //		case LANGUAGE['en-US']:
    //			return multiLanguageSubUrl.en_us
    //		case LANGUAGE['zh-CN']:
    //			return multiLanguageSubUrl.zh_cn
    //		case LANGUAGE['zh-HK']:
    //			return multiLanguageSubUrl.zh_hk
    //		default:
    //			return multiLanguageSubUrl.en_us
    //	}
    //}
    // To confirm
    // useEffect(() => {
    // 	try {
    // 		const url2_1 = getUrl2_1(languageInner)
    // 		const url2s = [url2_1]
    // 		stitcherGetLanguageFile(url2s, ({ state, data }) => {
    // 			if (state === 'success') {
    // 				const texts = data
    // 				if (Array.isArray(texts) && texts.length > 0) {
    // 					let result = { ...contentMessageState }
    // 					texts.map(item => (result = { ...result, ...item }))
    // 					setContentMessageState(result)
    // 				}
    // 			}
    // 		})
    // 	} catch (error) {
    // 		console.error('mfe-my-bfo-stitcher, failed to fetch multi-language', error)
    // 	}
    // }, [])
    return (react_1.default.createElement(react_intl_1.IntlProvider, { locale: languageInner, messages: contentMessageState }, props.children));
};
const globalErrorContainer = document.getElementById('global_error');
const globalErrorRoot = (0, client_1.createRoot)(globalErrorContainer);
const globalErrorRender = () => {
    globalErrorRoot.render(react_1.default.createElement(GlobalErrorHandler_1.GlobalErrorHandler, null));
};
exports.globalErrorRender = globalErrorRender;
